import { createAsyncThunk } from "@reduxjs/toolkit";
import { type Portfolio } from "../../../domain/entities/batch";
import { type BatchesDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const getCustody = createAsyncThunk<
  Portfolio[],
  { status: string; q: string },
  { dispatch: BatchesDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.GET_CUSTODY, async ({ status, q }, { extra }) => {
  return await extra.batchesRepo.getCustodyBoard(status, q);
});
